var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-outline 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.5 13.75H16.5C11.9437 13.75 8.25 17.4437 8.25 22V66C8.25 70.5564 11.9437 74.25 16.5 74.25H71.5C76.0564 74.25 79.75 70.5564 79.75 66V22C79.75 17.4437 76.0564 13.75 71.5 13.75Z",
    stroke: "#0A84FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.75 35.75C60.7876 35.75 63.25 33.2876 63.25 30.25C63.25 27.2124 60.7876 24.75 57.75 24.75C54.7124 24.75 52.25 27.2124 52.25 30.25C52.25 33.2876 54.7124 35.75 57.75 35.75Z",
    stroke: "#0A84FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.25 57.7137L36.6678 42.1608C35.6763 41.1694 34.3436 40.5942 32.9421 40.5527C31.5406 40.5112 30.1762 41.0065 29.1277 41.9373L8.25 60.4998M38.5 74.2498L59.6991 53.0508C60.6685 52.0793 61.9662 51.5055 63.3372 51.4419C64.7081 51.3783 66.0533 51.8295 67.1086 52.707L79.75 63.2498",
    stroke: "#0A84FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOutline);
export default __webpack_public_path__ + "static/media/image-outline.204a1f2a52e8ecc0b856e4ad708c18b4.svg";
export { ForwardRef as ReactComponent };